import { z } from 'zod'

import type { MapItem } from 'src/shared/schemas/utils'

export const refinanceReasonMap: Record<RefinanceReason, MapItem> = {
  lower_monthly_payment: { label: 'Lower Monthly Payment' },
  pay_off_mortgage_faster: { label: 'Pay Off Mortgage Faster' },
  take_cash_out: { label: 'Take Cash Out' },
  change_arm_loan_to_fixed: { label: 'Change ARM Loan to Fixed' },
  other: { label: 'Other' },
}

export const refinanceReasonSchema = z.enum(Object.keys(refinanceReasonMap) as [RefinanceReason, ...RefinanceReason[]])

export type RefinanceReason =
  | 'lower_monthly_payment'
  | 'pay_off_mortgage_faster'
  | 'take_cash_out'
  | 'change_arm_loan_to_fixed'
  | 'other'
